import {BunnyEnum, ContainerEnum, GetListParams, UserEnum} from "shared/types";
import {Coordinate} from "ol/coordinate";

export const ShippingSearchParamKey = {
  designatedSectorCodes: "designated_sector__code__in",
  mapCenterLat: "map_center_lat",
  mapCenterLng: "map_center_lng",
  mapZoom: "map_zoom",
  pickupBatchUuids: "pickup_batch__uuid__in",
  returnSellerUuids: "return_order__shop__uuid__in",
  search: "search",
  shippingShopUuids: "shipping_shop__uuid__in",
  shippingTimeDiffEndMinutes: "shipping_timestamp_difference_end_in_minute",
  shippingTimeDiffMinutes: "shipping_timestamp_difference_in_minute",
} as const;

export type ShippingBoxStatus = | "RETURNED" | "UNIT_RETURNED" | "CHECKIN" | "CHECKOUT" | "MOVINGTOUNIT" | "UNITARRIVED" | "CLAIMED" | "OUTFORDELIVERY" | "DELIVERYCOMPLETED" | "RETURNLATER";

export type ShippingContainerStatus = | "CHECKIN" | "CHECKOUT" | "UNITARRIVED" | "CLAIMED" | "OUTFORDELIVERY" | "DELIVERYCOMPLETED" | "UNIT_RETURNED" | "FINISHED";

export type SectorTypeV2 = {
  designated_sector__code: string;
  count: number;
};

export type SectorType = {
  id: string;
  code: string;
  name: string;
  area: string;
  pending_shipping_item_count?: number;
  pending_return_item_count?: number;
};

export interface GetSectorsAPIParams extends GetListParams {
  is_return?: boolean;
  status__in?: any[];
  completed?: boolean;
  ordering?: string;
  allowed?: "0" | "1";
  designated_sector__code__in?: any[];
  designated_sector__name__in?: any[];
  pickup_batch__uuid__in?: any[];
  shipping_container__uuid?: string;
  order__shop__name__in?: any[];
  search?: string;
}

export interface GetShippingAPIParams2 extends GetListParams {
  is_return?: boolean;
  status__in?: any[];
  completed?: boolean;
  designated_sector__code__in?: any[];
  designated_sector__name__in?: any[];
  shipping_container__uuid?: string;
  shipping_timestamp_difference_in_minute?: number; //now  -  selected datetime
  shipping_timestamp_difference_end_in_minute?: number; //now  -  selected end datetime
  order__shop__name__in?: any[];
  pickup_batch__uuid__in?: any[];
  shipping_shop__uuid__in?: any[];
  return_order__shop__uuid__in?: any[];
  search?: string;
  lat_max?: number;
  lng_max?: number;
  lat_min?: number;
  lng_min?: number;
  pickup_round?: "FIRST" | "SECOND" | "THIRD";
  pickup_day_offset?: "0" | "-1";
  shipping_container__user__uuid?: string;
  shipping_container__box__uuid?: string;
  filter_status?: "HUB_WORKING" | "HUB_BEFORE_SORTING" | "HUB_AFTER_SORTING";
}

export type SellerListType = {
  active: true;
  api_key: string;
  api_secret_key: string;
  daas_api_key: string;
  name: string;
  type: string;
  uuid: string;
};

export type SellerBatchType = {
  uuid: string;
  completed: boolean;
  timestamp_created: string;
  is_return: boolean;
  shipping_count: number;
  return_count: number;
  seller_name: string;
  round: string;
};

export type TBox = {
  uuid: string;
  alias: string;
  status: ShippingBoxStatus;
};

export type TAddressDetail = {
  name: string;
  address_road: string;
  address_jibun: string;
  address1: string;
  address2: string;
  lat: number;
  lng: number;
  zipcode: string;
  mobile_tel: string;
  sector?: SectorType;
};

export type TShippingItem = {
  address?: TAddressDetail;
  alias: string;
  seller_name: string;
  designated_sector?: SectorType;
  extra_memo: string;
  is_return: boolean;
  complete: boolean;
  highlighted: boolean;
  hovered: boolean;
  sorter_result: boolean;
  mobile_tel: string;
  status: ShippingBoxStatus;
  shipping_container?: ContainerApiResponse;
  timestamp_created: string;
  timestamp_delivery_complete: string;
  timestamp_delivery_incomplete: string;
  timestamp_return_collected: string;
  timestamp_return_complete: string;
  timestamp_return_created: string;
  timestamp_return_incomplete: string;
  tracking_number: string;
  uuid: string;
};

export type ContainerApiResponse = {
  box?: TBox;
  claim_expire: string;
  container_class: ContainerEnum;
  count_deliveries: number;
  count_remaining: number;
  count_return: number;
  count_return_collected: number;
  count_shipping: number;
  count_shipping_incomplete: number;
  count_total_items: number;
  duration: number;
  lastmile_without_box: boolean;
  push_assigned: boolean;
  pickup_only: boolean;
  is_plan: boolean;
  price: number;
  price_premium: number;
  sector?: SectorType;
  status: ShippingContainerStatus;
  timestamp_checkin: string; //생성일
  timestamp_claimed: string; //수락일
  timestamp_finished: string;
  timestamp_manual_assigned: string; //요청
  unit_location?: TAddressDetail;
  user?: RiderAccountType;
  uuid: string;
};

export interface RiderAccountType {
  rider_in_delivery_status: boolean;
  banned: boolean;
  fullname: string;
  is_active: boolean;
  is_available: boolean;
  permission_group: string[];
  phonenumber: string;
  type: UserEnum;
  username: string;
  bunny_type: BunnyEnum;
  ride_type: string;
  uuid: string;
}
